import { render, staticRenderFns } from "./mh-component-1.vue?vue&type=template&id=c3c4d55e"
import script from "./mh-component-1.vue?vue&type=script&lang=js"
export * from "./mh-component-1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports